import { Box, IconButton, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

const DialogHeader = ({ title, onClose }) => (
    <Box
      sx={{
        height: 56,
        px: 2,
        backgroundColor: '#2D2D6C',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
      }}
    >
      {/* 標題 */}
      <Typography fontSize={18} fontWeight="bold">
        {title}
      </Typography>

      {/* 關閉按鈕 */}
      <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 8,
          color: '#fff',
        }}
      >
        <CloseIcon />
      </IconButton>
    </Box>
  )

export default DialogHeader
